module.exports = __webpack_public_path__ + "static/media/add event.c0213f0d.svg";